import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconListOrderedComponent } from "./med-icon-list-ordered.component";

@NgModule({
  declarations: [
    MedIconListOrderedComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconListOrderedComponent,
  ],
})
export class MedIconListOrderedModule { }
